// extracted by mini-css-extract-plugin
export default {"footerlogo":"Footer_footerlogo__5nJwj","footerinfo":"Footer_footerinfo__6iF2x","footerblock":"Footer_footerblock__N3y20"};